exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:767px){#customerOrdersImagesModal:before{display:none}#customerOrdersImagesModal .modal-dialog{display:block}[dir] #customerOrdersImagesModal .modal-dialog{margin:0 auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a54a4fac","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orderDelivery/orderDeliveryCustomerImages.vue
// module id = 1371
// module chunks = 0